<template>

    <div class="container text-center" >
        <div v-if="showForm" class="unsubscribe-form">
            <div class="row">
                <div class="col-xl-12">
                    <h1>Unsubscribe</h1>
                    <p>from HouseMaster newsletters and text messages</p>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-12">
                    <div class="form-group">
                        <label for="email">Email</label>
                        <input type="email" name="email" v-model="email" />
                    </div>
                    <div class="form-group">
                        <label for="phone">Phone</label>
                        <input type="tel" name="phone" v-model="phone" />
                    </div>
                    <button @click="submitForm" class="btn btn-primary">Submit</button>

                </div>
            </div>
        </div>

        <div v-if="showSuccess" class="success-message">
            <h1>You have been successfully unsubscribed from HouseMaster newletters and SMS messages.</h1>
        </div>

        <div v-if="showFailure" class="failure-message">
            <h1>There was a problem with your request. Make sure you enter a valid email address and/or 10 digit phone number.</h1>
            <button @click="tryAgain" class="btn btn-primary">Try Again</button>
        </div>


        <!-- LOADING SPINNER -->
        <div class="loading" v-if="showSpinner">Loading&#8230;</div>

    </div>

</template>

<script>
    const axios = require('axios');

    export default {
        data: () => {
            return {
                email: '',
                phone: '',
                showSpinner: false,
                showForm: true,
                showSuccess: false,
                showFailure: false
            }
        },
        methods: {
            submitForm() {
                this.showSpinner = true;
                const data = {
                    phone: this.phone,
                    email: this.email
                };
                console.log(data);
                axios.post('https://udq74o4cmg.execute-api.us-west-2.amazonaws.com/dev/unsubscribe', {phone: this.phone, email:this.email, responseType: 'json'})
                    .then((response) => {
                        this.showSpinner = false;
                        this.showForm = false;
                        this.showSuccess = true;
                        console.log(response.data.body)

                    }).catch((error) => {
                        this.showSpinner = false;
                        this.showForm = false;
                        this.showFailure = true;
                    });
            },
            tryAgain() {
                this.showSpinner = false;
                this.showForm = true;
                this.showSuccess = false;
                this.showFailure = false;

            }
        }
    }
</script>

<style>
    body {
        background-color: #009578;
        color: #fff;
    }
    
    .btn-primary {
        border: 1px white solid;
        background-color: #009578;
        color: white;
        height: 26px;
        font-size: 12px;
        font-weight: 600;
        line-height: 16px;
        transition: background-color 300ms ease-out;
        -webkit-border-radius: 0;
        -moz-border-radius: 0;
        border-radius: 0;
        cursor: pointer;
        min-width: 200px;
        height: 30px;
    }

    .unsubscribe-form .btn-primary:hover {
        background-color: white;
        color: #009578;
    }

    /* Absolute Center Spinner */
    .loading {
        position: fixed;
        z-index: 999;
        height: 2em;
        width: 2em;
        overflow: show;
        margin: auto;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }

    /* Transparent Overlay */
    .loading:before {
        content: '';
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.3);
    }

    /* :not(:required) hides these rules from IE9 and below */
    .loading:not(:required) {
        /* hide "loading..." text */
        font: 0/0 a;
        color: transparent;
        text-shadow: none;
        background-color: transparent;
        border: 0;
    }

    .loading:not(:required):after {
        content: '';
        display: block;
        font-size: 10px;
        width: 1em;
        height: 1em;
        margin-top: -0.5em;
        -webkit-animation: spinner 1500ms infinite linear;
        -moz-animation: spinner 1500ms infinite linear;
        -ms-animation: spinner 1500ms infinite linear;
        -o-animation: spinner 1500ms infinite linear;
        animation: spinner 1500ms infinite linear;
        border-radius: 0.5em;
        -webkit-box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0, rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0, rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.5) -1.5em 0 0 0, rgba(0, 0, 0, 0.5) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0, rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
        box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0, rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0, rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) -1.5em 0 0 0, rgba(0, 0, 0, 0.75) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0, rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
    }

    /* Animation */

    @-webkit-keyframes spinner {
        0% {
            -webkit-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -ms-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            -moz-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
    @-moz-keyframes spinner {
        0% {
            -webkit-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -ms-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            -moz-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
    @-o-keyframes spinner {
        0% {
            -webkit-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -ms-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            -moz-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
    @keyframes spinner {
        0% {
            -webkit-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -ms-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            -moz-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
</style>


// WEBPACK FOOTER //
// Unsubscribe.vue?27017136